module.exports = __webpack_public_path__ + "img/logo-event.9e0132ac.svg";